@if (showClose()) {
  <ion-header>
    <ion-toolbar>
      <ion-title>{{ payee?.companyName }}</ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" (click)="dismiss()">
          <ion-icon name="close" slot="icon-only" />
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
}

<ion-content>
  <div class="modal-container">
    <!-- Status Messages -->
    @if (errorMessage || showSuccessMessage) {
      <div class="status-messages">
        @if (errorMessage) {
          <div class="alert-message error-message">
            <ion-icon name="alert-circle-outline" />
            <span>{{ errorMessage }}</span>
          </div>
        }
      </div>
    }

    <!-- Tab Navigation -->
    @if (!paymentOnly() && (isAdmin$ | async) === true && !!payee) {
      <div class="tab-container">
        <ion-segment
          [value]="selectedSegment || 'register'"
          (ionChange)="selectSegment($event)"
          class="custom-segment">
          <ion-segment-button value="register">
            <ion-icon name="person-outline" />
            <ion-label>Dados</ion-label>
          </ion-segment-button>
          <ion-segment-button value="bpa">
            <ion-icon name="shield-checkmark-outline" />
            <ion-label>BPA</ion-label>
          </ion-segment-button>
          <ion-segment-button value="composers">
            <ion-icon name="people-outline" />
            <ion-label>Compositores</ion-label>
          </ion-segment-button>
          <ion-segment-button value="accounts">
            <ion-icon name="link-outline" />
            <ion-label>Contas vinculadas</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
    }

    <form [formGroup]="payeeInfoForm"
      class="form-content"
      [class.form-content--accounts]="selectedSegment === 'accounts'">
      <ng-template #paymentInfoSection>
        <!-- Payment Information Section -->
        <div class="form-section" formGroupName="paymentInfo">
          <h3 class="section-title">
            <ion-icon name="cash-outline" />
            Informações de pagamento
          </h3>
          <div class="form-grid">
            <div class="form-field full-width">
              <ion-label class="field-label">Tipo de transferência</ion-label>
              <ion-select
                formControlName="type"
                okText="OK"
                cancelText="Cancelar"
                justify="start"
                interface="popover"
                class="custom-select">
                <ion-select-option value="PIX">PIX</ion-select-option>
                <ion-select-option value="TED">TED</ion-select-option>
                <ion-select-option value="OTHER">Outro</ion-select-option>
              </ion-select>
            </div>
            <!-- PIX Fields -->
            @if (payeeInfoForm.get('paymentInfo.type')?.value === paymentType.PIX) {
              <div class="form-field half-width">
                <ion-label class="field-label">Tipo de chave PIX</ion-label>
                <ion-select
                  formControlName="typeKey"
                  okText="OK"
                  cancelText="Cancelar"
                  justify="start"
                  interface="popover"
                  class="custom-select">
                  <ion-select-option value="CPF_CNPJ">CPF/CNPJ</ion-select-option>
                  <ion-select-option value="EMAIL">E-mail</ion-select-option>
                  <ion-select-option value="PHONE">Telefone</ion-select-option>
                  <ion-select-option value="RANDOM">Chave aleatória</ion-select-option>
                </ion-select>
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Chave PIX</ion-label>
                <ion-input formControlName="typeValue"
                  placeholder="Digite a chave PIX"
                  class="custom-input"
                  [errorText]="getBankFormatErrorText()" />
              </div>
            }
            <!-- TED Fields -->
            @if (payeeInfoForm.get('paymentInfo.type')?.value === paymentType.TED) {
              <div class="form-field half-width">
                <ion-label class="field-label">Banco</ion-label>
                <ion-input formControlName="bankName"
                  placeholder="Nome do banco"
                  class="custom-input" />
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Agência</ion-label>
                <ion-input formControlName="agency"
                  placeholder="Número da agência"
                  class="custom-input" />
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Conta</ion-label>
                <ion-input formControlName="account"
                  placeholder="Número da conta"
                  class="custom-input" />
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Titular da conta</ion-label>
                <ion-input formControlName="typeKey"
                  placeholder="Nome do titular"
                  class="custom-input" />
              </div>
              <div class="form-field full-width">
                <ion-label class="field-label">CPF / CNPJ do titular</ion-label>
                <ion-input formControlName="typeValue"
                  placeholder="Documento do titular da conta"
                  class="custom-input"
                  [errorText]="getBankFormatErrorText()" />
              </div>
            }
            <!-- OTHER Fields -->
            @if (payeeInfoForm.get('paymentInfo.type')?.value === paymentType.OTHER) {
              <div class="form-field half-width">
                <ion-label class="field-label">Método de pagamento</ion-label>
                <ion-input formControlName="typeKey"
                  placeholder="Ex: PayPal, Wise, etc."
                  class="custom-input" />
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Conta de pagamento</ion-label>
                <ion-input formControlName="typeValue"
                  placeholder="Dados da conta"
                  class="custom-input" />
              </div>
            }
          </div>
        </div>
      </ng-template>
      <!-- DADOS -->
      @if (!paymentOnly() && selectedSegment === 'register') {
        <div class="tab-content">
          <!-- Basic Information Section -->
          <div class="form-section">
            <div class="section-title-row">
              <h3 class="section-title">
                <ion-icon name="person-outline" />
                Cadastro
              </h3>
              @if (payee?.id && !payeeInfoForm.dirty) {
                <ion-button size="small" fill="outline" (click)="selectAsCurrentPayee()">
                  <ion-icon name="person-circle-outline" slot="start" />
                  Selecionar beneficiário
                </ion-button>
              }
            </div>
            <div class="form-grid">
              @if (!payee?.id && (isSuperadmin$ | async)) {
                <div class="form-field full-width">
                  <ion-label class="field-label">ID</ion-label>
                  <ion-input formControlName="id"
                    placeholder="ID do beneficiário (opcional)"
                    class="custom-input" />
                </div>
              }
              <div class="form-field full-width">
                <ion-label class="field-label">Nome</ion-label>
                <ion-input formControlName="companyName"
                  placeholder="Nome completo ou razão social"
                  class="custom-input"
                  errorText="Campo obrigatório" />
              </div>
              <ng-container formGroupName="internalProperties">
                <div class="form-field half-width">
                  <ion-label class="field-label">E-mail</ion-label>
                  <ion-input formControlName="email"
                    placeholder="email@exemplo.com"
                    type="email"
                    class="custom-input"
                    [errorText]="getEmailErrorText()" />
                </div>
                <div class="form-field half-width">
                  <ion-label class="field-label">Telefone / WhatsApp</ion-label>
                  <ion-input [ngClass]="phone1InputErrorClasses"
                    formControlName="phone1"
                    placeholder="(00) 00000-0000"
                    type="tel"
                    inputmode="tel"
                    maxlength="15"
                    class="custom-input"
                    [errorText]="getPhone1ErrorText()" />
                </div>
              </ng-container>
            </div>
          </div>
          <!-- Internal Information Section (Admin Only) -->
          @if ((isAdmin$ | async) === true) {
            <div class="form-section" formGroupName="internalProperties">
              <h3 class="section-title">
                <ion-icon name="shield-outline" />
                Informações internas
              </h3>
              <div class="admin-note">
                <ion-icon name="information-circle-outline" />
                <span>Visível apenas para administradores</span>
              </div>
              @if (payee?.id) {
                <div class="internal-id-reference">
                  <div class="id-info">
                    <span class="id-label">ID:</span>
                    <span class="id-value">{{ payee?.id }}</span>
                  </div>
                </div>
              }
              @if (payee?.payeeId) {
                <div class="internal-id-reference">
                  <div class="id-info">
                    <span class="id-label">Revelator Payee ID:</span>
                    <span class="id-value">{{ payee?.payeeId }}</span>
                  </div>
                </div>
              }
              <div class="form-grid">
                <div class="form-field share-field">
                  <ion-label class="field-label">% Share (autoral)</ion-label>
                  <ion-input formControlName="share"
                    placeholder="0-100"
                    inputmode="decimal"
                    maxlength="6"
                    min="0"
                    max="100"
                    type="number"
                    class="custom-input share-input"
                    [errorText]="getShareErrorText()" />
                </div>
                <div class="form-field full-width">
                  <ion-label class="field-label">Observações</ion-label>
                  <ion-textarea formControlName="notes"
                    placeholder="Notas e observações sobre o beneficiário"
                    rows="3"
                    class="custom-textarea" />
                </div>
              </div>
            </div>
          }
          <ng-container [ngTemplateOutlet]="paymentInfoSection"></ng-container>
        </div>
      }

      @if (paymentOnly()) {
        <div class="tab-content">
          <ng-container [ngTemplateOutlet]="paymentInfoSection"></ng-container>
        </div>
      }

      <!-- BPA -->
      @if (!paymentOnly() && selectedSegment === 'bpa') {
        <div class="tab-content" formGroupName="internalProperties">
          <!-- BPA Management Section -->
          <div class="form-section">
            <h3 class="section-title">
              <ion-icon name="shield-checkmark-outline" />
              Gestão da BPA
            </h3>
            <!-- Status Container -->
            <div class="status-container">
              <div class="status-info">
                <div class="status-chips">
                  <span class="status-label">Status:</span>
                  @if (auth.getPayeeStatus(payee) === auth.PayeeStatus.Active) {
                    <ion-chip color="success">
                      <ion-icon name="checkmark-circle-outline" color="success" />
                      <ion-label>Ativo</ion-label>
                    </ion-chip>
                  }
                  @if (auth.getPayeeStatus(payee) === auth.PayeeStatus.Invited) {
                    <ion-chip color="warning">
                      <ion-icon name="time-outline" color="warning" />
                      <ion-label>Convidado</ion-label>
                    </ion-chip>
                  }
                  @if (auth.getPayeeStatus(payee) === auth.PayeeStatus.NotInvited) {
                    <ion-chip color="danger">
                      <ion-icon name="close-circle-outline" color="danger" />
                      <ion-label>Não convidado</ion-label>
                    </ion-chip>
                  }
                </div>
                <div class="status-details">
                  @if (payee.internalProperties?.lastSignIn) {
                    <div class="status-note">
                      <ion-icon name="time-outline" />
                      <span>Último acesso: {{ getTimestamp(payee.internalProperties?.lastSignIn) | date:'dd/MM/yyyy HH:mm' }}</span>
                    </div>
                  }
                  @if (payee.internalProperties?.invitedAt) {
                    <div class="status-note">
                      <ion-icon name="mail-outline" />
                      <span>Convite enviado em: {{ getTimestamp(payee.internalProperties?.invitedAt) | date:'dd/MM/yyyy HH:mm' }}</span>
                    </div>
                  }
                  @if (payee.internalProperties?.invitedAt && payee.internalProperties?.invitedBy) {
                    <div class="status-note">
                      <ion-icon name="person-outline" />
                      <span>Convidado por: {{ payee.internalProperties?.invitedBy }}</span>
                    </div>
                  }
                  @if (!payee.internalProperties?.invitedAt && payee.internalProperties?.removedBy) {
                    <div class="status-note">
                      <ion-icon name="person-remove-outline" />
                      <span>Convite removido por: {{ payee.internalProperties?.removedBy }}</span>
                    </div>
                  }
                  @if (payee.internalProperties?.contract?.clickId) {
                    @if (payee.internalProperties?.contract?.signedDate) {
                      <div class="status-note">
                        <ion-icon name="document-text-outline" />
                        <span>Contrato assinado em: {{ getTimestamp(payee.internalProperties?.contract?.signedDate) | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                    } @else {
                      <div class="status-note warning">
                        <ion-icon name="alert-circle-outline" />
                        <span>Contrato ainda não assinado</span>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
            <!-- Document Information -->
            <div class="form-grid">
              <div class="form-field half-width">
                <ion-label class="field-label">Tipo de documento</ion-label>
                <ion-select
                  formControlName="taxIdType"
                  okText="OK"
                  cancelText="Cancelar"
                  justify="start"
                  interface="popover"
                  class="custom-select">
                  <ion-select-option value="CPF">CPF</ion-select-option>
                  <ion-select-option value="CNPJ">CNPJ</ion-select-option>
                  @if ((isAdmin$ | async) === true) {
                    <ion-select-option value="OTHER">
                      Outro
                    </ion-select-option>
                  }
                </ion-select>
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Número do documento</ion-label>
                <ion-input [ngClass]="formErrorClasses"
                  formControlName="taxId"
                  placeholder="Digite o número do documento"
                  class="custom-input"
                  [errorText]="getFormatErrorText()" />
              </div>
              <div class="form-field half-width">
                <ion-label class="field-label">Data de nascimento</ion-label>
                <ion-input formControlName="birthDate"
                  type="date"
                  class="custom-input date-input" />
              </div>
              <!-- Configuration Grid -->
              @if (configService.getContractTypes() | async; as contractTypes) {
                <div class="form-field half-width" formGroupName="contract">
                  <ion-label class="field-label">Contrato</ion-label>
                  <ion-select
                    formControlName="clickId"
                    okText="OK"
                    cancelText="Cancelar"
                    justify="start"
                    interface="popover"
                    class="custom-select">
                    <ion-select-option value="">(Externo)</ion-select-option>
                    @for (contractType of contractTypes; track contractType) {
                      <ion-select-option [value]="contractType.id">
                        {{ contractType.name }}
                      </ion-select-option>
                    }
                  </ion-select>
                </div>
              }
              <div class="form-field half-width">
                <div class="checkbox-container">
                  <ion-checkbox formControlName="publishingOnly" class="custom-checkbox" />
                  <ion-label class="checkbox-label">Apenas autoral (sem acesso ao painel)</ion-label>
                </div>
              </div>
            </div>
            <!-- Actions Container -->
            @if (!payee?.internalProperties?.parentPayee) {
              <div class="actions-container">
                <div class="payee-email-display">
                  @if (payeeInfoForm.get('internalProperties.email')?.value || payee?.internalProperties?.email) {
                    <div class="email-info">
                      <ion-icon name="mail-outline" />
                      <span class="email-text">{{ payeeInfoForm.get('internalProperties.email')?.value || payee.internalProperties.email }}</span>
                    </div>
                  }
                </div>
                <div class="action-buttons">
                  @if (payee?.internalProperties?.blocked) {
                    <ion-button
                      color="success"
                      fill="solid"
                      [disabled]="requesting"
                      (click)="unblockPayee()"
                      class="action-button">
                      @if (requesting) {
                        <ion-spinner name="lines-small" slot="start" />
                      }
                      @if (!requesting) {
                        <ion-icon name="lock-open-outline" slot="start" />
                      }
                      <span>Desbloquear</span>
                    </ion-button>
                  }
                  @if (!payee?.internalProperties?.blocked) {
                    <ion-button
                      color="warning"
                      fill="solid"
                      [disabled]="requesting"
                      (click)="blockPayee()"
                      class="action-button">
                      @if (requesting) {
                        <ion-spinner name="lines-small" slot="start" />
                      }
                      @if (!requesting) {
                        <ion-icon name="ban-outline" slot="start" />
                      }
                      <span>Bloquear</span>
                    </ion-button>
                  }
                  @if (auth.canSendInvite(payee) && !payee?.internalProperties?.blocked) {
                    <ion-button
                      color="secondary"
                      fill="solid"
                      [disabled]="!payeeInfoForm.valid || requesting || !payeeInfoForm.get('internalProperties.email')?.value || !payeeInfoForm.get('internalProperties.taxId')?.value || payeeInfoForm.get('internalProperties.taxId')?.invalid"
                      (click)="sendInvitation()"
                      class="action-button">
                      @if (requesting) {
                        <ion-spinner name="lines-small" slot="start" />
                      }
                      @if (!requesting) {
                        <ion-icon name="person-add-outline" slot="start" />
                      }
                      <span>Enviar convite</span>
                    </ion-button>
                  }
                  @if (auth.canResendInvite(payee) && !payee?.internalProperties?.blocked) {
                    <ion-button
                      color="secondary"
                      fill="solid"
                      [disabled]="!payeeInfoForm.valid || requesting || !payeeInfoForm.get('internalProperties.taxId')?.value || payeeInfoForm.get('internalProperties.taxId')?.invalid"
                      (click)="sendInvitation()"
                      class="action-button">
                      @if (requesting) {
                        <ion-spinner name="lines-small" slot="start" />
                      }
                      @if (!requesting) {
                        <ion-icon name="person-add-outline" slot="start" />
                      }
                      <span>Reenviar convite</span>
                    </ion-button>
                  }
                  @if (auth.canRemoveAccess(payee)) {
                    <ion-button
                      color="danger"
                      fill="solid"
                      [disabled]="!payeeInfoForm.valid || requesting"
                      (click)="removeAccess()"
                      class="action-button">
                      @if (requesting) {
                        <ion-spinner name="lines-small" slot="start" />
                      }
                      @if (!requesting) {
                        <ion-icon name="person-remove-outline" slot="start" />
                      }
                      <span>Remover acesso</span>
                    </ion-button>
                  }
                </div>
              </div>
            }
          </div>
          <!-- Parent Payee Notice -->
          @if (payee?.internalProperties?.parentPayee) {
            <div class="form-section">
              <div class="parent-payee-notice">
                <ion-icon name="information-circle-outline" />
                <span>Não é possível enviar convite para este beneficiário, pois ele já está vinculado ao beneficiário: <strong>{{ parentPayee?.companyName }}</strong></span>
              </div>
            </div>
          }
        </div>
      }

      <!-- COMPOSITORES -->
      @if (!paymentOnly() && selectedSegment === 'composers') {
        <div class="tab-content" formGroupName="internalProperties">
          <!-- Composers Management Section -->
          <div class="form-section">
            <h3 class="section-title">
              <ion-icon name="people-outline" />
              Compositores
            </h3>
            <div class="composers-header">
              <ion-button
                color="secondary"
                fill="solid"
                (click)="addComposer()"
                class="add-composer-button">
                <ion-icon name="add-outline" slot="start" />
                <span>Adicionar compositor</span>
              </ion-button>
            </div>
            <div formArrayName="composers" class="composers-list">
              @for (composerItem of getSortedComposers(); track trackComposer(i, composerItem); let i = $index) {
                <div
                  [formGroupName]="composerItem.index"
                  class="composer-item">
                  <input type="hidden" formControlName="id"/>
                  <div class="composer-form">
                    <div class="form-row">
                      <div class="form-field flex-grow">
                        <ion-label class="field-label">Nome do compositor</ion-label>
                        <ion-input formControlName="companyName"
                          placeholder="Digite o nome do compositor"
                          class="custom-input" />
                      </div>
                      <div class="form-field action-field">
                        <ion-button
                          color="danger"
                          fill="outline"
                          size="small"
                          (click)="removeComposer(composerItem.index)"
                          class="remove-button">
                          <ion-icon name="trash-outline" slot="start" />
                          <span>Remover</span>
                        </ion-button>
                      </div>
                    </div>
                    @if (composerItem.control.value.id) {
                      <div class="internal-id-reference">
                        <div class="id-info">
                          <span class="id-label">ID:</span>
                          <span class="id-value">{{ composerItem.control.value.id }}</span>
                        </div>
                        <ion-button
                          fill="clear"
                          size="small"
                          (click)="convertComposerToBeneficiary(composerItem.control.value.id, composerItem.control.value.companyName)"
                          class="convert-composer-button">
                          <ion-icon name="person-add-outline" slot="start" />
                          <span>Converter em beneficiário</span>
                        </ion-button>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (getComposersArray().controls.length === 0) {
                <div class="no-composers">
                  <ion-icon name="musical-notes-outline" />
                  <span>Nenhum compositor adicionado</span>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <!-- CONTAS VINCULADAS -->
      @if (!paymentOnly() && selectedSegment === 'accounts') {
        <div class="tab-content">
          <!-- Parent Payee Notice -->
          @if (payee?.internalProperties?.parentPayee) {
            <div class="form-section">
              <div class="parent-payee-notice">
                <ion-icon name="link-outline" />
                <span>Este beneficiário está vinculado ao beneficiário: <strong>{{ parentPayee?.companyName }}</strong></span>
              </div>
            </div>
          }
          <!-- Linked Accounts Section -->
          @if (!payee?.internalProperties?.parentPayee) {
            <div class="linked-accounts-section">
              <app-payees-list type="inline"
                [isLinkedPayeeSelection]="true"
                [selectedPayee]="payee?.id"
                [selectedPayees]="payeeInfoForm.get('internalProperties.linkedPayees')?.value || []"
                (payeeSelected)="onPayeeSelected($event)"
                (createPayee)="onPayeeSelected(null)" />
          </div>
        }
      </div>
    }
  </form>
</div>
</ion-content>

<!-- Inline modal for converting composer to beneficiary -->
<ion-modal
  class="convert-composer-alert-modal"
  [isOpen]="isConvertModalOpen"
  [backdropDismiss]="true"
  [presentingElement]="presentingElementEl"
  (didDismiss)="closeConvertComposerModal()">
  <ng-template>
    <div class="convert-alert-container">
      <div class="convert-alert-icon">
        <ion-icon name="alert-circle-outline"></ion-icon>
      </div>
      <h2 class="convert-alert-title">⚠️ LEIA COM ATENÇÃO!</h2>
      <div class="convert-alert-message">
        <p>Ao converter este compositor, ele passará a ser um <strong>Beneficiário individual</strong>, recebendo diretamente pela Berger Mobile.</p>
        <p>Ele terá acesso aos relatórios existentes e poderá solicitar o recebimento de valores em aberto.</p>
        <p>Caso haja valores pendentes, o beneficiário principal terá esse montante <strong>deduzido do total</strong>.</p>
        <p class="danger-text">ESTA AÇÃO É IRREVERSÍVEL!</p>
        <p>Deseja prosseguir?</p>
        <div class="form-field full-width" style="margin-top: 12px;">
          <ion-label class="field-label">E-mail do novo beneficiário</ion-label>
          <ion-input
            placeholder="email@exemplo.com"
            type="email"
            class="custom-input"
            [(ngModel)]="convertEmail"
            name="convertEmail" />
        </div>
      </div>
      <div class="convert-alert-actions">
        <ion-button fill="clear" color="medium" (click)="closeConvertComposerModal()">Cancelar</ion-button>
        <ion-button color="danger" [disabled]="convertCountdown > 0 || !isValidEmail(convertEmail) || requesting" (click)="confirmConvertComposer()">
          @if (requesting) {
            <ion-spinner name="lines-small" slot="start" />
          }
          {{ convertCountdown > 0 ? 'Prosseguir (' + convertCountdown + ')' : 'Prosseguir' }}
        </ion-button>
      </div>
    </div>
  </ng-template>
  
</ion-modal>

<ion-footer class="modal-footer">
  <ion-toolbar>
    <div class="footer-actions">
      @if (getFormErrors()) {
        <div class="form-errors">
          <ion-icon name="alert-circle-outline" />
          <span>{{ getFormErrors() }}</span>
        </div>
      }
      <div class="save-actions">
        <ion-button
          fill="clear"
          color="medium"
          (click)="dismiss()"
          [disabled]="requesting"
          class="cancel-button">
          <span>Cancelar</span>
        </ion-button>

        <ion-button
          fill="solid"
          color="primary"
          (click)="save()"
          [disabled]="!payeeInfoForm.dirty || !payeeInfoForm.valid || requesting"
          class="save-button">
          @if (requesting) {
            <ion-spinner name="lines-small" slot="start" />
          }
          @if (!requesting) {
            <ion-icon name="save-outline" slot="start" />
          }
          <span>{{ requesting ? 'Salvando...' : 'Salvar' }}</span>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>